import { ChangeDetectionStrategy, Component, Input, QueryList, ViewChildren } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

import { Workflow } from '@shared/store/workflow/workflow.store';

import { ChecklistNotesEditorComponent } from './checklist-notes-editor/checklist-notes-editor.component';
import { Notes } from './notes.enum';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ChecklistNotesEditorComponent],
  selector: 'aux-checklist-notes',
  styleUrl: './checklist-notes.component.scss',
  templateUrl: './checklist-notes.component.html',
})
export class ChecklistNotesComponent {
  @Input() checklistAdminPermission!: boolean;
  @ViewChildren(ChecklistNotesEditorComponent) editors!: QueryList<ChecklistNotesEditorComponent>;
  readonly Notes = Notes;
  @Input() workflow$!: BehaviorSubject<null | Workflow>;
}
